<button
  mat-button
  [class]="
    [
      design,
      size,
      outlined ? 'outlined' : '',
      disabled ? 'disabled' : '',
      rounded ? 'rounded' : '',
      class
    ].join(' ')
  "
  [disabled]="disabled"
>
  <ng-content></ng-content>
</button>
